var margin = {top: 40, right: 15, bottom: 0, left: 5};

var widther = d3.select(".gia-chart-wrapper").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 450 - margin.top - margin.bottom;

var barHeight = 25;  

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.scale.linear()
	.range([0,width]);

//Creates the yScale
var y0 = d3.scale.ordinal()
	.rangeBands([height, 0], 0)
	.domain(["Education", "Social Security", "Immigration", "Health", "Discrimination", "Job security", "Foreign policy", "Campaign finance/political corruption", "Economic inequality", "Other", "Climate change"]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
	.scale(y0)
	.orient("left");

//Defines the x axis styles
var xAxis = d3.svg.axis()
	.scale(xScale)
	.orient("top")
  	.tickFormat(function(d) {return d + "%"; })
  	.tickPadding(15)
	.tickSize(-height)
  	.ticks(5); 

//Defines the x axis styles
var altX = d3.svg.axis()
	.scale(xScale)
	.orient("top")
  	.tickPadding(-5)
	.tickSize(5)
  	.ticks(5);   	

//Loads the data
d3.csv("data/votervoices.csv", ready);

function ready(err, data) {

	if (err) throw "error loading data";

	//FORMAT data
	data.forEach(function(d) {
		d.percent = +d.percent;
	});

	console.log(data);

	//Sets the max for the xScale
	var maxX = d3.max(data, function(d) { return d.percent; });

	//Defines the xScale max
	xScale.domain([0, maxX ]);

	//Appends the y axis
	var yAxisGroup = svg.append("g")
		.attr("class", "y axis")
		.attr("transform", "translate(9,-20)")
		.call(yAxis);	

  //Binds the data to the bars    	
	var categoryGroup = svg.selectAll(".g-category-group")
		.data(data)
		.enter()
		.append("g")
		.attr("class", "g-category-group")
		.attr("transform", function(d) {
			return "translate(0," + y0(d.category) + ")";
		});

	//Appends first bar		
	var bars = categoryGroup.append("rect")
		.attr("width", function(d) { return xScale(d.percent); })
		.attr("height", y0.rangeBand()/3 )
		.attr("class", "g-percent")
		.attr("transform", "translate(0,4)");

	//Appends the altX axis
	var xAltGroup = svg.append("g")
		.attr("class", "alt x")
		.attr("transform", "translate(0,-14)")
		.call(altX)
		.selectAll("g")
		.classed("g-baseline", function(d) {return d == 0});	

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0,-8)")
		.call(xAxis)
		.selectAll("g")
		.classed("g-baseline", function(d) {return d == 0});

	var textGroup = svg.selectAll(".g-text-group")
		.data(data)
		.enter()
		.append("g")
		.attr("class", "g-text-group")
		.attr("transform", function(d) {
			return "translate(0," + y0(d.category) + ")";
		});	

	var labels = textGroup.append("text")
		.attr("class", "labels")
		.attr("x", 0)
		.attr("y", y0.rangeBand()/4 - 10)
		.text(function(d) { return (d.category);});
				

		//RESPONSIVENESS
		d3.select(window).on("resize", resized);

		function resized() {

			//new margin
		    var newMargin = {top: 40, right: 15, bottom: 0, left: 5};

		    var newWidther = d3.select(".gia-chart").node().clientWidth;

    		var newWidth = newWidther - newMargin.left - newMargin.right;

		    //Get the width of the window
		    var w = d3.select(".gia-chart").node().clientWidth;

		    //Change the width of the svg
    		d3.select("svg")
      			.attr("width", newWidth + newMargin.left + newMargin.right);

    		//Change the xScale
    		xScale
      			.range([0, newWidth]);

		    //Update the bars
		    bars.attr("width", function(d) { return xScale(d.percent); });  

		    //Updates xAxis
    		d3.selectAll(".x.axis")
         		.call(xAxis);     

    		//Updates ticks
    		xAxis
      			.scale(xScale)
      			.ticks(5);

      		//Updates xAxis
    		d3.selectAll(".alt.x")
         		.call(altX); 	
		};
	}